export * from './SimpleModal.types';
export { default as SimpleModal } from './SimpleModal';
